import { create, StateCreator } from "zustand";
import { devtools } from "zustand/middleware";
import { ApplicationUiSlice } from "./application-ui-store-model";

const createApplicationDomElementsUiSlice: StateCreator<ApplicationUiSlice, [['zustand/devtools', never]], [], ApplicationUiSlice> = (set) => ({
    appDomElementClientHeightRef: {
        appDomElementNavigationHeader: 0, // should set as first it should follow the dom layer first loads cames first
        domElementOffsetA: 0, //should set as second
        domElementOffsetB: 0, // should set as third
        domElementOffsetC: 0 // should set as fourth
    },
    setAppDomElementClientHeightRef: (data) => {
        set((state) => {
            return {
                appDomElementClientHeightRef: { ...state.appDomElementClientHeightRef, ...data }
            }
        }, false, 'set/DOM_SET')
    },
    clearAppDomElementClientHeightRef: () => set(() => ({ appDomElementClientHeightRef: { appDomElementNavigationHeader: 0, domElementOffsetA: 0, domElementOffsetB: 0, domElementOffsetC: 0 } }), false, 'clear/CLEAR_DOM')
});

export const useApplicationUiStore =
    create<ApplicationUiSlice>()(
        devtools((...a) => ({
            ...createApplicationDomElementsUiSlice(...a),
        }), { name: 'App-UI', store: 'appUI' })
    );